import { render } from "./ProjectTagLink.vue?vue&type=template&id=20e7915d&scoped=true"
import script from "./ProjectTagLink.vue?vue&type=script&lang=js"
export * from "./ProjectTagLink.vue?vue&type=script&lang=js"

import "./ProjectTagLink.vue?vue&type=style&index=0&id=20e7915d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e7915d"]])

export default __exports__